export const MODEL_DEFECT_LOCATION = {
  SMOOTHING: {
    key: "SMOOTHING",
    translation: "failureReasons.local.SMOOTHING",
  },
  DLP: {
    key: "DLP",
    translation: "failureReasons.local.DLP",
  },
  COLOR: {
    key: "COLOR",
    translation: "failureReasons.local.COLOR",
  },
  FDM_BAMBU: {
    key: "FDM_BAMBU",
    translation: "failureReasons.local.FDM_BAMBU",
  },
  FDM_PRUSA: {
    key: "FDM_PRUSA",
    translation: "failureReasons.local.FDM_PRUSA",
  },
  FDM_STRATASYS: {
    key: "FDM_STRATASYS",
    translation: "failureReasons.local.FDM_STRATASYS",
  },
  HP_D: {
    key: "HP_D",
    translation: "failureReasons.local.HP_D",
  },
  HP_E: {
    key: "HP_E",
    translation: "failureReasons.local.HP_E",
  },
  HP_F: {
    key: "HP_F",
    translation: "failureReasons.local.HP_F",
  },
  HP_G: {
    key: "HP_G",
    translation: "failureReasons.local.HP_G",
  },
  HP_H: {
    key: "HP_H",
    translation: "failureReasons.local.HP_H",
  },
  ASSEMBLY: {
    key: "ASSEMBLY",
    translation: "failureReasons.local.ASSEMBLY",
  },
  MSLA_ANYCUBIC: {
    key: "MSLA_ANYCUBIC",
    translation: "failureReasons.local.MSLA_ANYCUBIC",
  },
  ADDITION: {
    key: "ADDITION",
    translation: "failureReasons.local.ADDITION",
  },
  PSLA: {
    key: "PSLA",
    translation: "failureReasons.local.PSLA",
  },
  POLYJET: {
    key: "POLYJET",
    translation: "failureReasons.local.POLYJET",
  },
  SLA: {
    key: "SLA",
    translation: "failureReasons.local.SLA",
  },
  SLM_A: {
    key: "SLM_A",
    translation: "failureReasons.local.SLM_A",
  },
  SLM_B: {
    key: "SLM_B",
    translation: "failureReasons.local.SLM_B",
  },
  SLS_A: {
    key: "SLS_A",
    translation: "failureReasons.local.SLS_A",
  },
  SLS_B: {
    key: "SLS_B",
    translation: "failureReasons.local.SLS_B",
  },
  SLS_C: {
    key: "SLS_C",
    translation: "failureReasons.local.SLS_C",
  },
  SLS_FUSE_1: {
    key: "SLS_FUSE_1",
    translation: "failureReasons.local.SLS_FUSE_1",
  },
  RAYS: {
    key: "RAYS",
    translation: "failureReasons.local.RAYS",
  },
  OTHER: {
    key: "OTHER",
    translation: "failureReasons.local.OTHER",
  },
};

export const MODEL_DEFECT_TYPE = {
  PRINTING_PLATE_DIRTY: {
    key: "PRINTING_PLATE_DIRTY",
    translation: "failureReasons.type.PRINTING_PLATE_DIRTY",
  },
  PRINTING_PLATE_DEFECTIVE: {
    key: "PRINTING_PLATE_DEFECTIVE",
    translation: "failureReasons.type.PRINTING_PLATE_DEFECTIVE",
  },
  SURFACE_ROUGH: {
    key: "SURFACE_ROUGH",
    translation: "failureReasons.type.SURFACE_ROUGH",
  },
  ELEPHANT_SKIN: {
    key: "ELEPHANT_SKIN",
    translation: "failureReasons.type.ELEPHANT_SKIN",
  },
  WRONG_ORIENTATION: {
    key: "WRONG_ORIENTATION",
    translation: "failureReasons.type.WRONG_ORIENTATION",
  },
  COLORING: {
    key: "COLORING",
    translation: "failureReasons.type.COLORING",
  },
  THERMAL_BLEED: {
    key: "THERMAL_BLEED",
    translation: "failureReasons.type.THERMAL_BLEED",
  },
  STRIPS_FLAT: {
    key: "STRIPS_FLAT",
    translation: "failureReasons.type.STRIPS_FLAT",
  },
  STRIPS_RAISED: {
    key: "STRIPS_RAISED",
    translation: "failureReasons.type.STRIPS_RAISED",
  },
  BUBBLES: {
    key: "BUBBLES",
    translation: "failureReasons.type.BUBBLES",
  },
  DIMENSIONAL_DEVIATION: {
    key: "DIMENSIONAL_DEVIATION",
    translation: "failureReasons.type.DIMENSIONAL_DEVIATION",
  },
  DELAY: {
    key: "DELAY",
    translation: "failureReasons.type.DELAY",
  },
  DAMAGE: {
    key: "DAMAGE",
    translation: "failureReasons.type.DAMAGE",
  },
  ABORTED_PRINT: {
    key: "ABORTED_PRINT",
    translation: "failureReasons.type.ABORTED_PRINT",
  },
  DURING_SUPPORTING: {
    key: "DURING_SUPPORTING",
    translation: "failureReasons.type.DURING_SUPPORTING",
  },
  LOST: {
    key: "LOST",
    translation: "failureReasons.type.LOST",
  },
  OTHER_DEFECTS: {
    key: "OTHER_DEFECTS",
    translation: "failureReasons.type.OTHER_DEFECTS",
  },
};

export const MODEL_DEFECT_ORIGIN_STATES = {
  printingCount: "PRINTING",
  receivedCount: "RECEIVED",
  postProcessingCount: "POSTPROCESSING",
  qaCount: "QA",
  readyForShippingCount: "READY_FOR_SHIPPING",
};
